import { createSessionMarker, defineNuxtPlugin, hasDepositStarted, isDomDesyncError, markDomDesyncReload, reloadNuxtApp, useRouter, useState } from '#imports'

// A deposit page Vue can no longer patch ignores every click until it is reloaded, and a reload almost always
// brings it back. Deposit pages only: elsewhere a reload costs more (a running game) for less.
// Only before any deposit starts on this page load, so a reload never interrupts a payment.

// Per path. Longer than reloadNuxtApp's default: whatever broke the page is still there after the reload. Kept in its
// own entry, because reloadNuxtApp's `nuxt:reload` is shared and a long TTL there holds back chunk and outdated-build reloads.
const RELOAD_GUARD_TTL = 5 * 60_000

export default defineNuxtPlugin({
    name: 'dom-desync-reload',
    setup(nuxtApp) {
        const router = useRouter()
        // usePayments' busy flag.
        const processing = useState<boolean>('payments:processing', () => false)

        nuxtApp.hook('vue:error', (error) => {
            if (!router.currentRoute.value.meta.isDeposit || !isDomDesyncError(error)) return
            if (hasDepositStarted() || processing.value) return

            // The deposit app sets ?view itself and the server drops it, so leave it out to keep the guard on one path.
            const url = new URL(window.location.href)
            url.searchParams.delete('view')

            const path = url.pathname + url.search
            // Fails closed: without sessionStorage nothing stops a reload loop.
            if (!createSessionMarker(`core:dom-desync-reload-guard:${path}`, RELOAD_GUARD_TTL).claim()) return

            // This plugin's own guard above decides; reloadNuxtApp's 10s guard must not swallow a reload it already spent.
            reloadNuxtApp({ path, force: true })
            markDomDesyncReload()

            // No input while the reload loads, so no deposit can start on the page being left. Back can restore
            // this page from the bfcache when the reload navigated to a new entry, and it must take input again.
            document.body.inert = true
            window.addEventListener('pageshow', () => document.body.inert = false, { once: true })
        })
    },
})
